import { convertToShamsi } from "utils/dateCoverter";
import "./PreFaktorPrintHeader.scss";
const PreFaktorPrintHeader = ({
  prefaktorInfo,
  // customerNamePrefix,
  // customerName,
  // customerPhoneNumber,
  // customerAddress,
  // faktorId,
  // faktorDate,
  // clearingDate
}) => {
  return (
    <div className="prefaktor-print-header-container">
      <div className="prefaktor-print-header-company-name w-100 d-flex justify-content-center align-items-center flex-column">
        <h2 className="mt-2">شرکت بیستاتِک</h2>
        <h4 className="iranyekan-bold">پیش فاکتور</h4>
      </div>
      <div className="prefaktor-print-header-company-name w-100 d-flex">
        <div className="prefaktor-print-header-customer-info p-3 d-flex justify-content-start flex-column">
          <div>
            <span className="font-size-14 me-1 iranyekan-bold">
              شرکت/آقای/خانم:
            </span>
            <span className="font-size-14 me-1">
              {`${prefaktorInfo?.people?.name} ${prefaktorInfo?.people?.family} `}
            </span>
          </div>
          <div>
            <span className="font-size-14 me-1 iranyekan-bold">تلفن:</span>
            <span className="font-size-14 me-1 ">
              {prefaktorInfo.people?.phone}
            </span>
          </div>
          <div>
            <span className="font-size-14 me-1 iranyekan-bold">آدرس:</span>
            <span className="font-size-14 me-1">
              {prefaktorInfo.people?.address}
            </span>
          </div>
        </div>
        <div className="prefaktor-print-header-faktor-info">
          <div>
            <span className="font-size-14 me-1 iranyekan-bold">شماره:</span>
            <span className="font-size-14 me-1">{prefaktorInfo.id}</span>
          </div>
          <div>
            <span className="font-size-14 me-1 iranyekan-bold">تاریخ:</span>
            <span className="font-size-14 me-1" dir="rtl">
              {convertToShamsi(prefaktorInfo.date) || null}
            </span>
          </div>
          <div>
            <span className="font-size-14 me-1 iranyekan-bold">تلفن:</span>
            <span className="font-size-14 me-1" dir="rtl">
              09120699155
            </span>
          </div>
          <div>
            <span className="font-size-14 me-1 iranyekan-bold">
              مهلت تسویه:
            </span>
            <span className="font-size-14 me-1" dir="rtl">
              {prefaktorInfo.clearing_date
                ? convertToShamsi(prefaktorInfo.clearing_date)
                : " - - - "}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreFaktorPrintHeader;
